import { Component, Input, OnInit, OnDestroy, ElementRef } from "@angular/core";
import { FilterService, PopupCloseEvent, SinglePopupService } from "@progress/kendo-angular-grid";
import { CompositeFilterDescriptor } from "@progress/kendo-data-query";
import { addDays } from '@progress/kendo-date-math';

const closest = (node: any, predicate: any): any => {
    while (node && !predicate(node)) {
        node = node.parentNode;
    }

    return node;
};

const DATE_RANGE_TITLE = 'date-range-filter';

@Component({
    selector: DATE_RANGE_TITLE,
    template: `
        <div class="k-form">
            <label class="k-form-field">
                <span>Start</span>
                <kendo-datepicker (valueChange)="onStartChange($event)"
                    [(ngModel)]="start" [max]="max" [popupSettings]="popupSettings">
                </kendo-datepicker>
            </label>
            <label class="k-form-field">
                <span>End</span>
                <kendo-datepicker (valueChange)="onEndChange($event)"
                    [(ngModel)]="end" [min]="min" [popupSettings]="popupSettings">
                </kendo-datepicker>
            </label>
        </div>
   `,
    styles: [`
        .k-form {
            padding: 5px;
        }
   `]
})
export class DateRangeFilterComponent implements OnInit, OnDestroy {

    @Input() public filter: CompositeFilterDescriptor;
    @Input() public filterService: FilterService;
    @Input() public field: string;

    public start: Date;
    public end: Date;

    public get min(): any {
        return this.start ? addDays(this.start, 1) : null;
    }

    public get max(): any {
        return this.end ? addDays(this.end, -1) : null;
    }

    public popupSettings: any = {
        popupClass: DATE_RANGE_TITLE
    };

    private popupSubscription: any;

    constructor(private element: ElementRef,
        private popupService: SinglePopupService) {

        // Handle the service onClose event and prevent the menu from closing when the datepickers are still active.
        this.popupSubscription = popupService.onClose.subscribe((e: PopupCloseEvent) => {
            if (document.activeElement && closest(document.activeElement,
                node => node === this.element.nativeElement || (String(node.className).indexOf(DATE_RANGE_TITLE) >= 0))) {
                e.preventDefault();
            }
        });
    }

    public ngOnInit(): void {
        this.start = this.findValue('gte');
        this.end = this.findValue('lte');
    }

    public ngOnDestroy(): void {
        this.popupSubscription.unsubscribe();
    }

    public onStartChange(value: any): void {
        this.filterRange(value, this.end);
    }

    public onEndChange(value: any): void {
        this.filterRange(this.start, value);
    }

    private findValue(operator) {
        const filter = this.filter.filters.filter((x: any) => x.field === this.field && x.operator === operator)[0];
        return filter ? new Date(filter['value']) : null;
    }

    private filterRange(start, end) {
        const filters = [];
        if (start) start = new Date(start);
        if (end) end = new Date(end);

        if (start && (!end || start < end)) {
            filters.push({
                field: this.field,
                operator: "gte",
                value: start
            });
            this.start = start;
        }

        if (end && (!start || start < end)) {
            filters.push({
                field: this.field,
                operator: "lte",
                value: end
            });
            this.end = end;
        }

        this.filterService.filter({
            logic: "and",
            filters: filters
        });
    }
}
